import { createContext, useContext } from 'react'

import type { User } from './api/client'

export type AddFoodRequest = { day: string; meal?: number; mode?: 'scan' | 'photo' | 'describe' | 'search' | 'quick' }

export type AppCtx = {
  user: User
  unit: 'kg' | 'lb'
  openAdd: (req: AddFoodRequest) => void
  goTo: (tab: 'dashboard' | 'log' | 'plan' | 'trends' | 'stats' | 'more') => void
}

export const AppContext = createContext<AppCtx | null>(null)

export function useApp(): AppCtx {
  const v = useContext(AppContext)
  if (!v) throw new Error('AppContext missing')
  return v
}
